import { Injectable } from '@angular/core';
import { Permission, PermissionRequest } from '../models/permission.model';
import { map, Observable, of, switchMap } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { environment } from 'src/environments/environment';
import { Store } from '@ngxs/store';
import { PermissionSelectors } from '../store/premission.selector';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {

  private apiUrl = `${environment.sgcApi}`;
  private permissionRoute = 'LevelModulePermission';

  constructor(
    public store: Store,
    private httpClient: HttpClient,
    private authenticationService: AuthenticationService,
  ) { }

  getPermissions(): Observable<Permission[]> {
    let endpoint = `${this.apiUrl}${this.permissionRoute}`;
    return  this.httpClient.get<any>(endpoint).pipe(
      map(data => data)
    );
  }

  canShowItem(pathUrl: string): Observable<boolean> {
    return this.authenticationService.getValidToken().pipe(
      switchMap((token) => {
        const userLevel = this.authenticationService.getUserLevel(token);
        return this.hasPermissions(userLevel, pathUrl).pipe((response => {
          return response
        }));
      })
    );
  }

  updatePermissions(permissions: PermissionRequest[], user: string) {
    let endpoint = `${this.apiUrl}${this.permissionRoute}/user/${user}`;
    return  this.httpClient.put(endpoint, JSON.stringify(permissions)).pipe(
      map(data => data)
    );
  }
  private hasPermissions(level: string, pathUrl: string): Observable<boolean> {
     return this.getPermissions().pipe(map((permissions) => {
       return permissions.some(permission => permission.levelPermissions.includes(level) && (permission.urlSgc2.indexOf(pathUrl) === 0))
     }));
   }
}
